export default __webpack_public_path__ + "static/media/landing-page-hero-image.7fa8f1f4.png";